import { Component, computed, effect, input } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { DynamicField } from '@shared/components/dynamic-form/models/field';
import { Selection } from '@shared/components/dynamic-form/models/field-base';
import { DynamicChoicesSettings } from '@shared/components/dynamic-form/models/field-dynamic-choices';

@Component({
  selector: 'app-choices-rating-field',
  imports: [NgbTooltipModule, TranslateModule],
  templateUrl: './choices-rating-field.component.html',
})
export class ChoicesRatingFieldComponent {
  field = input.required<DynamicField>();
  form = input.required<FormGroup>();
  editable = input<boolean>(true);

  items = computed(() => {
    return (
      (this.field()?.settings as DynamicChoicesSettings)?.choice?.selections ||
      []
    );
  });

  get formControl() {
    return this.form().controls[this.field().key] as AbstractControl<number>;
  }

  currentIndex = 0;

  constructor() {
    effect(() => {
      this.updateSelectedIndex();
    });
  }

  onChangeChoice(e: Event) {
    const value = (e.target as HTMLInputElement).value;
    this.form().get(this.field().key)?.setValue(+value);
  }

  updateSelectedIndex(): void {
    if (this.formControl.value) {
      const selectedIndex = this.items().findIndex(
        (i: Selection) => i.score === this.formControl.value
      );
      this.currentIndex = selectedIndex === -1 ? 0 : selectedIndex;
    }
  }
}
